import { CameraType } from '../enums/cameraType';
import { Event } from '../interfaces';

export const isContextCamera = (event: Event): boolean => {
  return event.metadata?.event_detection_camera === CameraType.Context;
};
